import script from "./mprn-property-lookup.vue?vue&type=script&setup=true&lang=ts"
export * from "./mprn-property-lookup.vue?vue&type=script&setup=true&lang=ts"

import "./mprn-property-lookup.vue?vue&type=style&index=0&id=dcb557c6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dcb557c6"]])

export default __exports__